import DEFINE from "./define";
import ToolBase from "./basic";
export default class DefineControl {
    static #instance

    constructor() {
    }
    /**
     *
     * @type {DefineControl}
     * @readonly
     * @static
     * @memberof DefineControl
     */
    static get Instance() {
        if(this.#instance == null) {
            this.#instance = new DefineControl();
        }
        return this.#instance;
    }
    /**
     * 
     * @param {Object} obj 
     * @param {ToolBase} toolBase 
     */
    setDefaultControl(obj, toolBase, control = true) {
        if(control) {
            obj.set({
                hasBorders: false,
                cornerColor: DEFINE.COLOR.CORNER_COLOR,
                transparentCorners: false,
                controls: Object.assign(toolBase.getBasicControls(), {
                    deleteControl: toolBase.getDeleteControl({
                        x: 0.5,
                        y: -0.5,
                        offsetX: 25,
                        offsetY: 0,
                    }),
                    mtr: toolBase.getTouchRotateControl({
                        x: 0.5,
                        y: 0,
                        offsetX: 25,
                        offsetY: 0,
                    })
                })
            })
        }else {
            obj.set({
                hasBorders: false,
                cornerColor: DEFINE.COLOR.CORNER_COLOR,
                transparentCorners: false,
                controls: Object.assign(toolBase.getBasicControls(), {
                    
                })
            })
        }
    }
}